<script>
import formatDate from '@utils/format-date'
import lazyLoadComponent from '@router/lazyload-component'
import { messageBoxDelete } from '@utils/message-box'
import { nlToBr } from '@utils'

export default {

  components: {

  },
  filters: {
    formatDate,
  },
  props: {
    defaultValue: {
      type: Array,
      default: () => []
    },
    isOrder: {
      type: Boolean,
      default: false
    },
    isEmployee: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  },
  computed: {
    currentUserGroupIds() {
      return this.$store.state.auth.currentUser.groups
    },
    hasPermission() {
      return this.currentUserGroupIds.includes(7) || this.currentUserGroupIds.includes(8)
    },
    userId() {
      return this.$store.state.auth.currentUser.id
    },
  },
  watch: {
  },
  created() {
    
  },
  mounted() {
  },
  methods: {
    nlToBr,
    tryToDeleteCommemt() {
      
    },
    async onClickRemove(id) {
      await messageBoxDelete('備註')
      this.$emit('remove', id)
    },
    editCommemt(item) {
      this.$emit('edit', item)
    }
  },
}
</script>

<template>
  <div :class="$style.MemberInfoCommentList">
    <template v-if="defaultValue.length">
      <template v-if="!isEmployee && isOrder">
        <p class="fs-lg mb-3 fw-medium text-text MemberInfoCommentList__title my-0">
          客戶備註
          <span class="fs-2sm text-text-light fw-regular">(客戶無法查看)</span>
        </p>
        <el-divider></el-divider>
      </template>
      <ul>
        <li 
          v-for="(item, index) in defaultValue"
          :key="index"
          class="MemberInfoCommentList__item"
        >
          <div class="text-secondary" v-html="nlToBr(item.content)"></div>
          <div class="d-flex mt-3 justify-content-between flex-lg-nowrap flex-wrap">
            <div class="text-text-light ml-2 align-self-center">-{{ item.updatedAt | formatDate() }} {{item.creator.name}}</div>
            <div class="ml-auto">
              <el-button 
                v-if="hasPermission || userId === item.creator.id"
                type="text"
                size='mini'
                @click="editCommemt(item)"
              >
                <BaseIcon name="edit" class="text-primary fs-xl align-text-top"/>
                編輯
              </el-button>
              <el-button 
                v-if="hasPermission || userId === item.creator.id"
                type="text"
                size='mini'
                class="ml-2"
                @click="onClickRemove(item.id)"
              >
                <BaseIcon name="trash-alt" class="text-primary fs-xl align-text-top"/>
                刪除
              </el-button>
            </div>
          </div>
        </li>
      </ul>
      
    </template>
    <template v-else>
      尚無任何備註
    </template>
  </div>
</template>

<style lang="scss" module>
.MemberInfoCommentList {
  :global {
    .MemberInfoCommentList {
      &__title {

      }
      &__item {
        
        line-height: 1.65;
        &:not(:last-child) {
          border-bottom: 1px dashed $color-line;
          padding-bottom: 1rem;
          margin-bottom: 1.25rem;
        }
      }
    }
  }
}
</style>
